export function makeIsNumber<T>(errorMsg: T) {
  return (value: unknown) => {
    const v = Number(value);

    return !v || typeof v !== 'number' ? errorMsg : undefined;
  };
}
